








































import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { faSave } from '@fortawesome/free-solid-svg-icons'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import {
  SET_INVALID_TRIGGERED,
  SET_REQUIRES_PAYMENT,
  SET_SHOW_FLOATING_SAVE_BUTTON,
  SET_TERMS_ACCEPTED
} from '~/store/modules/shared/classifieds/form/mutation-types'
import { APP_NS } from '~/store/modules/shared/app/state'
import { Corner, FloatingCornerElementName } from '~/models/layout'
import { PAGE_NS } from '~/store/modules/shared/page/state'
import { mapDeps } from '~/plugins/dependency-container/utils'
import UserAgentService from '~/services/UserAgentService'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import useClassifiedFormSubmit from '~/compositions/form/submit'
import NewPaidClassifiedAlert from '~/components/car/classifieds/form/footer/NewPaidClassifiedAlert.vue'

export default {
  components: {
    NewPaidClassifiedAlert
  },
  setup() {
    const { submitForm } = useClassifiedFormSubmit()

    function onSubmitButtonClick() {
      submitForm()
    }

    function onFloatingSaveButtonClick() {
      submitForm({ scroll: false })
    }

    return {
      onSubmitButtonClick,
      onFloatingSaveButtonClick
    }
  },
  computed: {
    icons: () => ({
      save: faSave
    }),
    ...mapState(CLASSIFIED_FORM_NS, {
      price: state =>
        state.fieldValues?.price?.price || state.fieldValues?.price,
      model: state => state.fieldValues?.makemodel?.model,
      months: state => state.fieldValues?.price?.months,
      editMode: state => state.editMode,
      loading: state => state.loading,
      categoryIds: state => state.categoryIds,
      pageKey: state => state.pageKey,
      invalidTriggered: state => state.invalidTriggered,
      showFloatingSaveButton: state => state.showFloatingSaveButton,
      requiresPayment: state => state.requiresPayment,
      termsAccepted: state => state.termsAccepted
    }),
    ...mapGetters(APP_NS, {
      isPlot: 'isPlot'
    }),
    ...mapGetters(CLASSIFIED_FORM_NS, {
      noModelsForThisMake: 'noModelsForThisMake',
      getAllFields: 'getAllFields',
      requiresTerms: 'requiresTerms',
      hasPrice: 'hasPrice',
      isRentalsForm: 'isRentalsForm',
      isJobsForm: 'isJobsForm'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    }),
    ...mapDeps({
      userAgentService: UserAgentService
    }),
    termsPath() {
      if (this.isPlot) {
        return '/information/faq/terms/'
      }
      return '/information/terms/'
    }
  },
  mounted() {
    this.setInvalidTriggered(false)
    if (this.editMode) {
      this.addCornerElement({
        name: FloatingCornerElementName.SAVE_BUTTON,
        corner: Corner.BOTTOM_RIGHT,
        componentInstance: this
      })
    }
  },
  methods: {
    ...mapActions(PAGE_NS, {
      addCornerElement: 'addCornerElement'
    }),
    ...mapActions(CLASSIFIED_FORM_NS, {
      fieldChanged: 'fieldChanged',
      submitEditClassified: 'submitEditClassified',
      submitNewClassified: 'submitNewClassified',
      validateClient: 'validateClient'
    }),
    ...mapMutations(CLASSIFIED_FORM_NS, {
      setShowFloatingSaveButton: SET_SHOW_FLOATING_SAVE_BUTTON,
      setInvalidTriggered: SET_INVALID_TRIGGERED,
      setRequiresPayment: SET_REQUIRES_PAYMENT,
      setTermsAccepted: SET_TERMS_ACCEPTED
    }),
    termsChanged(termsAreAccepted: boolean) {
      this.fieldChanged({
        field: { name: 'accepted_terms', value: termsAreAccepted }
      })
      this.setTermsAccepted(termsAreAccepted)
    },
    submitButtonVisibilityChanged(isVisible: boolean) {
      this.setShowFloatingSaveButton(!isVisible)
    },
    onRequiresPaymentChange(requiresPayment: boolean) {
      this.setRequiresPayment(requiresPayment)
    }
  }
}
